import type { HeadersWithoutIterator } from 'owa-service/lib/RequestOptions';
import { setHeaders } from 'owa-headers-core';
import { getExplicitLogonHeaders } from './getExplicitLogonHeaders';

export default function setExplicitLogonHeaders(
    smtp: string | undefined | null,
    headers: HeadersWithoutIterator | undefined | null,
    prefixedId?: string
) {
    if (headers && (smtp || prefixedId)) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (14,53): Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        setHeaders(headers, getExplicitLogonHeaders(smtp, prefixedId));
    }
}
